import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomTable from "../../../../components/table/table";
import ResourseCard from "../../../../components/page/tiles/resourcecard";
import {
  download_expert_man_power_file,
  user_get_advisor_details,
  user_get_manpower_details,
} from "../../user.api";

import "../style.css";
import BreadCrumbsComp from "../../../../components/navigator/breadcrumbs";
import Loader from "../../../../components/loader/loader";
let count = 100;
export default function AdvisorDetails(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const selectedParam = useParams();
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const getDetails = (id) => {
    user_get_advisor_details(id).then((res) => {
      let tdata = res.data;

      setData(tdata);
      setIsActive(false);
    });
  };
  useEffect(() => {
    getDetails(selectedParam.id);
  }, []);
  const handleDownloadResume = (data) => {
    let path = `${result}${data}`;
    window.open(path, "_blank");
  };
  const handleDownloadDocument = async (id) => {
    if (!id) {
      console.error("User ID is missing for download");
      return;
    }

    try {
      const response = await download_expert_man_power_file(id);

      // Extract the file URL from the response
      const fileUrl = response?.url;

      if (!fileUrl) {
        console.error("Invalid response: No URL found in API response.");
        return;
      }

      // Open the file in a new tab
      const newTab = window.open(fileUrl, "_blank");

      // Handle cases where the browser blocks pop-ups
      if (!newTab) {
        alert("Popup blocked! Please allow popups for this site.");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  const handleDownload = (dt) => {
    let path = `${result}${dt.file_upload_certificate}`;
    window.open(path, "_blank");
  };
  const handleExpDownload = (dt) => {
    let path = `${result}${dt.experience_certificate}`;
    window.open(path, "_blank");
  };

  return (
    <div className="">
      <Loader open={isActive} />
      <BreadCrumbsComp section="advisor_details" />
      <div className="container p-50">
        <div className="res-page-cont-details">
          <div className="row tender-head ">
            <h4> KSPACE Advisor Details </h4>
          </div>
          <div className="row ">
            <div className="col-xs-12 ">
              <div className="res-bannerContainer d-flex ">
                <div className="">
                  <div className="res-ban-data">
                    <div>
                      <img
                        src={`${result}${data?.photo}`}
                        className="res-profile-img"
                        alt=""
                      />
                    </div>
                    <div className="profile-res-con">
                      <div className="res-person-name">
                        {data?.name ? data?.name : ""}
                      </div>
                      <div className="qualification-container">
                        <div className="res-exp">Domain Types</div>
                        <div className="expertise-tags">
                          {(data?.domain_types || []).map((item, i) => (
                            <span key={i} className="expertise-tag">
                              {item.domain_name}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="data details-card">
                {data?.designation && (
                  <div className="row">
                    <div className="col-3">Designation</div>
                    <div className="col-1">:</div>
                    <div className="col-7">{data?.designation}</div>
                  </div>
                )}
                <div className="row">
                  <div className="col-3">Resume</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <button
                      className="btn btn-approved btn-success mt-2"
                      onClick={() => handleDownloadResume(data?.biodata)}
                    >
                      Download Resume
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">Contact Email</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{data?.email}</div>
                </div>
                <div className="row">
                  <div className="col-3">Contact Phone Number</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{data?.mobile}</div>
                </div>
                <div className="row">
                  <div className="col-3">Address</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{data?.address}</div>
                </div>
                <div className="row">
                  <div className="col-3">Expert in</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <div className="expertise-tags">
                      {(data?.domain_types || []).map((item, i) => (
                        <span key={i} className="expertise-tag">
                          {item.domain_name}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
